import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Transition } from "@headlessui/react";

import useTheme from "hooks/useTheme";
import useNotification from "hooks/useNotification";

import { getAccountAmountById, getAccountInfoById } from "actions/accounts";
// import { fundAlgoInNewAccount, fundAssetInNewAccount, optInAssetToAccount } from "actions/transactions";
// import { buildingComponent, sendingTransaction } from "actions/loaders";
import { getAssetPricesByAlammex } from "actions/assets";

import BalancesLoader from "theme/loaders/dashboard/BalancesLoader";
// import HelpMeOutModal from "theme/modals/dashboard/balances/HelpMeOutModal";

import ASANotVerifiedIcon from "theme/icons/ASANotVerified";
import ASARenownedIcon from "theme/icons/ASARenowned";
import ASANotableIcon from "theme/icons/ASANotable";
import ASAVerifiedStandardIcon from "theme/icons/ASAVerifiedStandard";
import ASAFlaggedIcon from "theme/icons/ASAFlagged";
import SendIcon from "theme/icons/Send";
import AlammexIcon from "theme/icons/Alammex";
import Currencies from "common/currencies/Currencies";
import CopyIcon from "theme/icons/Copy";

import StyledTooltipWithoutArrow from "theme/tooltips/StyledTooltipWithoutArrow";
import useRefresh from "hooks/useRefresh";
import { buildingComponent } from "actions/loaders";

const Balances = () => {
	const dispatch = useDispatch();
	const { appLanguage, themeColor, baseCurrency } = useTheme();
	const { notify } = useNotification();
	const { isRefresh } = useRefresh();

	const accountInfo = useSelector((state) => state.AccountInfo);
	const fetchingDataFromApi = useSelector((state) => state.FetchingDataFromApi);
	const buildingComponentLoader = useSelector((state) => state.BuildingComponent);
	const algoChain = useSelector((state) => state.AppPreferences.algoChain);

	const [assets, setAssets] = useState(null);
	// const [helpMeOutModalIsOpen, setHelpMeOutModalIsOpen] = useState(false);
	// const [helpMeOutModalInfo, setHelpMeOutModalInfo] = useState(null);
	// const [helpMeOutAssets, setHelpMeOutAssets] = useState(null);

	const [currency, setCurrency] = useState(null);

	useEffect(() => {
		if (accountInfo?.assets) {
			setAssets(null);
			generateAssetListWithInfoByAccountAssets(accountInfo.assets);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [accountInfo]);

	useEffect(() => {
		if (baseCurrency && baseCurrency["currency-code"]) {
			setCurrency(Currencies(themeColor?.hex, baseCurrency["currency-code"]));
		}
	}, [baseCurrency, themeColor]);

	const generateAssetListWithInfoByAccountAssets = async (assets) => {
		dispatch(buildingComponent(true));

		let assetsArray = [];

		const algorandAsset = {
			"asset-id": -1,
			name: "Algorand",
			"unit-name": "Algo",
			deleted: false,
			amount: accountInfo?.amount,
			verification: {
				reputation: "Verified",
			},
			decimals: 6,
		};

		const assetPrices = await getAssetPricesByAlammex();

		for (let asset of assets) {
			if (asset?.["is-nft"] === false && asset?.deleted === false)
				try {
					assetsArray.push({
						...asset,
						price: assetPrices[asset["asset-id"]],
					});
				} catch (error) {
					console.error(error);
				}
		}

		assetsArray = [...assetsArray].sort((a, b) => b.amount - a.amount);

		assetsArray.unshift({
			...algorandAsset,
			price:
				baseCurrency["currency-code"] === "algo"
					? accountInfo?.amount
					: await getAccountAmountById(accountInfo?.address, baseCurrency["currency-code"], algoChain).then((data) => {
							if (data) return data?.amount;
					  }),
		});

		setAssets(assetsArray);

		dispatch(buildingComponent(false));
	};

	// const HelpMeOut = async () => {
	// 	const assetsArray = [];
	// 	const data = await getHelpMeOutQuote(algoChain);

	// 	if (data?.algo && data?.assets) {
	// 		for (let asset of data.assets) {
	// 			if (asset?.index !== "-1") assetsArray.push(asset.index);
	// 		}

	// 		setHelpMeOutAssets(assetsArray);

	// 		setHelpMeOutModalInfo({
	// 			title: (
	// 				<div className="flex flex-col w-full items-center justify-center space-y-2">
	// 					<p className={`text-sm font-bold ${themeColor?.text}`}>Funding Your Account</p>
	// 					<p className={`text-sm font-bold ${themeColor?.text}`}>
	// 						{accountInfo["account-address"].slice(0, 5)}...{accountInfo["account-address"].slice(-5)}
	// 					</p>
	// 				</div>
	// 			),
	// 			message: (
	// 				<div className="flex flex-col items-center justify-center">
	// 					<p className={`text-sm font-bold ${themeColor?.text}`}>These will be transferred to your account</p>
	// 					<div className="flex items-center space-x-1">
	// 						<p className={`text-sm ${themeColor?.text}`}>{data?.algo?.amount}</p>
	// 						<p className={`text-sm ${themeColor?.text}`}>{data?.algo?.params?.["unit-name"]}</p>
	// 					</div>
	// 					{data["assets"].map((asset, index) => (
	// 						<div className="flex items-center space-x-1" key={index}>
	// 							<p className={`text-sm ${themeColor?.text}`}>{asset?.amount}</p>
	// 							<p className={`text-sm ${themeColor?.text}`}>{asset?.params?.["unit-name"]}</p>
	// 						</div>
	// 					))}
	// 				</div>
	// 			),
	// 		});

	// 		setHelpMeOutModalIsOpen(true);
	// 	}
	// };

	// const FundNewAccount = async () => {
	// 	dispatch(sendingTransaction(true));

	// 	const data = await fundAlgoInNewAccount(
	// 		{
	// 			"receiver-account": accountInfo["account-address"],
	// 		},
	// 		algoChain
	// 	);

	// 	if (data?.data) {
	// 		console.log("account funded now opting in assets");

	// 		for (let helpMeOutAsset of helpMeOutAssets) {
	// 			const data = await optInAssetToAccount(
	// 				{
	// 					"account-address": accountInfo["account-address"],
	// 					"asset-id": parseInt(helpMeOutAsset),
	// 				},
	// 				algoChain
	// 			);

	// 			console.log(data);
	// 		}

	// 		const assetFunding = await fundAssetInNewAccount(
	// 			{
	// 				receiverAccount: accountInfo["account-address"],
	// 			},
	// 			algoChain
	// 		);

	// 		if (assetFunding) {
	// 			setHelpMeOutModalIsOpen(false);
	// 			dispatch(getAccountInfoById(accountInfo["account-address"], algoChain));
	// 		}
	// 	}

	// 	dispatch(sendingTransaction(false));
	// };

	useEffect(() => {
		if (isRefresh) if (isRefresh) dispatch(getAccountInfoById(accountInfo?.address, algoChain));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isRefresh]);

	return (
		<Transition
			as={Fragment}
			appear={true}
			show={true}
			enter="transition-opacity duration-500"
			enterFrom="opacity-0"
			enterTo="opacity-100"
		>
			<div className="flex flex-col w-full space-y-2 py-3">
				{fetchingDataFromApi || buildingComponentLoader ? (
					<BalancesLoader />
				) : accountInfo?.error && accountInfo?.code === 404 ? (
					<div className="flex w-full items-center justify-center pt-10">
						<div className="flex flex-col w-full items-center justify-center space-y-4">
							<div className="flex flex-col w-full items-center justify-center text-center">
								<p
									className={`text-sm font-bold ${themeColor?.text}`}
									dangerouslySetInnerHTML={{ __html: appLanguage?.fundNewAccountMessage }}
								/>
							</div>
							<div className="flex flex-col w-full items-center justify-center text-center">
								<p className={`text-sm font-bold ${themeColor?.text}`}>
									{accountInfo?.["account-address"].slice(0, 5) +
										"..." +
										accountInfo?.["account-address"].slice(-5)}
								</p>

								<CopyIcon
									className={`w-4 cursor-pointer`}
									fill={themeColor?.hex}
									onClick={() => {
										navigator.clipboard.writeText(accountInfo?.["account-address"]);
										notify("success", "Copied to clipboard");
									}}
								/>
							</div>
							{/* <div className="flex flex-col w-full items-center justify-center space-y-1">
								<p className={`text-sm font-bold ${themeColor?.text}`}>or, click below</p>
								<p className={`text-sm font-bold ${themeColor?.text}`}>we'll happy to help</p>
							</div>
							<button
								className={`text-sm text-white ${themeColor?.bg} px-3 py-2 rounded-lg hover:shadow-lg`}
								onClick={() => HelpMeOut()}
							>
								Help me out
							</button> */}
						</div>
					</div>
				) : assets?.length ? (
					assets.map(
						(asset, index) =>
							asset?.deleted === false && (
								<div className="flex w-full items-center justify-between pr-5" key={index}>
									<Link
										to="/AssetInfo"
										state={{ assetID: asset["asset-id"], assetInfo: asset }}
										className="w-full flex items-center space-x-8"
									>
										<img
											className={`w-8 ${themeColor?.text}`}
											alt="asset"
											loading="lazy"
											src={`${process.env.REACT_APP_DAFFI_MAINNET_URL}/assets/image?assetID=${asset["asset-id"]}&width=30`}
										/>

										<div className="flex items-center space-x-2">
											<div className="flex flex-col items-end">
												{asset?.verification ? (
													asset?.verification?.reputation === "Verified" ? (
														<StyledTooltipWithoutArrow
															title={appLanguage?.notableFullyVerified}
															children={
																<ASARenownedIcon className="w-4 h-4" fill={themeColor?.hex} />
															}
														/>
													) : asset?.verification?.reputation === "Notable" ? (
														<StyledTooltipWithoutArrow
															title={appLanguage?.knownAuthenticated}
															children={
																<ASANotableIcon className={`w-4 h-4`} fill={themeColor?.hex} />
															}
														/>
													) : asset?.verification?.reputation === "Neutral" ? (
														<StyledTooltipWithoutArrow
															title={appLanguage?.standardVerified}
															children={
																<ASAVerifiedStandardIcon
																	className="w-4 h-4"
																	fill={themeColor?.hex}
																/>
															}
														/>
													) : asset?.verification?.reputation === "Unsafe" ? (
														<StyledTooltipWithoutArrow
															title={appLanguage?.flagged}
															children={
																<ASAFlaggedIcon className="w-4 h-4" fill={themeColor?.hex} />
															}
														/>
													) : (
														(asset?.verification?.reputation === "Not Verified" ||
															asset?.verification?.reputation === "") && (
															<StyledTooltipWithoutArrow
																title={appLanguage?.notAvailable}
																children={
																	<ASANotVerifiedIcon className="w-5" fill={themeColor?.hex} />
																}
															/>
														)
													)
												) : (
													<StyledTooltipWithoutArrow
														title={appLanguage?.notAvailable}
														children={<ASANotVerifiedIcon className="w-5" fill={themeColor?.hex} />}
													/>
												)}

												{/* <StyledTooltipWithoutArrow
														title={appLanguage?.notAvailable}
														children={
															<ASANotVerifiedIcon className="w-5" fill={themeColor?.hex} />
														}
													/> */}
												<ASANotVerifiedIcon className="w-5" fill="#FFFFFF" />
											</div>
											<div className="flex-col flex">
												<p className={`text-sm font-bold ${themeColor?.text}`}>
													{asset?.["unit-name"]
														? asset["unit-name"]
														: asset?.name
														? asset.name
														: "Unnamed"}
												</p>
												<p className={`text-xs ${themeColor?.text}`}>{asset?.name}</p>
											</div>
										</div>
									</Link>

									<div className="flex w-fit items-center space-x-7">
										<div className="flex flex-col items-center justify-end">
											<div className="flex justify-end w-full">
												<p className={`text-sm font-bold ${themeColor?.text}`}>
													{(asset.amount / Math.pow(10, asset.decimals)).toLocaleString(undefined, {
														maximumFractionDigits: 4,
														minimumFractionDigits: 4,
													})}
												</p>
											</div>

											<div className="flex w-full text-right justify-end space-x-1">
												{/* check if asset is algorand then set currency icon as base currency otherwise use default */}
												{asset["asset-id"] === -1 ? (
													<div className="flex items-center space-x-0.5">
														<p className={`text-xs ${themeColor?.text}`}>
															{(baseCurrency["currency-code"] === "algo"
																? accountInfo["amount-without-pending-rewards"] / 1000000
																: accountInfo["amount-without-pending-rewards-in-base-currency"]
															).toLocaleString(undefined, {
																maximumFractionDigits: 2,
																minimumFractionDigits: 2,
															})}
														</p>
														<div className="w-2.5">{currency?.icon}</div>
													</div>
												) : asset?.price && asset?.amount !== -1 ? (
													<div className="flex items-center space-x-0.5">
														<p className={`text-xs ${themeColor?.text}`}>
															{(baseCurrency["currency-code"] === "algo"
																? asset?.["total-price-in-algorand"]
																: asset?.["total-price-in-base-currency"]
															).toLocaleString(undefined, {
																maximumFractionDigits: 2,
																minimumFractionDigits: 2,
															})}
														</p>
														<div className="w-2.5">{currency?.icon}</div>
													</div>
												) : (
													<p className={`text-xs font-bold ${themeColor?.text}`}>-</p>
												)}
											</div>
										</div>

										<div className="flex w-fit items-center space-x-3">
											<StyledTooltipWithoutArrow
												title={appLanguage?.send}
												children={
													<Link to="/Send" state={{ asset: asset }}>
														<SendIcon className="w-5" fill={themeColor?.hex} />
													</Link>
												}
											/>
											<StyledTooltipWithoutArrow
												title={appLanguage?.convert}
												children={
													<Link to="/Swap" state={{ asset: asset }}>
														<AlammexIcon className="w-5" fill={themeColor?.hex} />
													</Link>
												}
											/>
										</div>
									</div>
								</div>
							)
					)
				) : (
					<p className={`text-md ${themeColor?.text}`}>{appLanguage?.noBalancesFound}</p>
				)}

				{/* <HelpMeOutModal
					isOpen={helpMeOutModalIsOpen}
					setIsOpen={setHelpMeOutModalIsOpen}
					modalInfo={helpMeOutModalInfo}
					action={() => FundNewAccount()}
				/> */}
			</div>
		</Transition>
	);
};

export default Balances;
